export default __webpack_public_path__ + "static/media/ShowSomeoneSpecial.d206eb81.svg";